// Import Swiper library and modules
import { Swiper } from "swiper";
import { Navigation, Pagination, Autoplay, EffectFade } from "swiper/modules";

// Import Swiper CSS
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

window.Swiper = Swiper;

// Public function to initialize swipers
function initializeSwipers(container = document) {
    let sliders = container.querySelectorAll(".swiper-slider");

    sliders.forEach((slider) => {
        // Skip if already initialized
        if (slider.swiper) return;

        let settings = {};
        let modules = { modules: [] };

        settings["modules"] = [];
        if (slider.dataset.modulenav) {
            modules["modules"].push(Navigation);
        }

        if (slider.dataset.modulepagination) {
            modules["modules"].push(Pagination);
        }

        if (slider.dataset.moduleautoplay) {
            modules["modules"].push(Autoplay);
        }

        if (slider.dataset.moduleeffect) {
            modules["modules"].push(EffectFade);
        }

        if (slider.dataset.settings) {
            try {
                settings = JSON.parse(slider.dataset.settings);
            } catch (e) {
                console.warn('Invalid JSON in slider settings:', e);
                return;
            }
        }

        settings = merge(modules, settings);

        try {
            let swiper = new Swiper(slider, settings);
        } catch (e) {
            console.error('Error initializing Swiper:', e);
        }
    });
}

// Make the function globally available
window.initializeSwipers = initializeSwipers;

// Initialize swipers on page load
initializeSwipers();

function merge(modules, settings) {
    for (var key in settings) {
        if (settings.hasOwnProperty(key)) modules[key] = settings[key];
    }
    return modules;
}
